<button  [class]="getButtonClass()" [type]="type" [disabled]="disabled">
  @if (isLoading) {
    <img class="circle-loader" src="/assets/images/loaders/Ellipse.svg" alt="" />
  } @else {
    <span class="text-1">{{ title }}</span>
  }
</button>
